import { Button, Text } from '@viapeople/components'
import { useState } from 'react'

type IntegrationType = 'crm' | 'webhook'

interface SelectIntegrationTypeStepProps {
	onSelect: (type: IntegrationType) => void
	onCancel: () => void
}

export function SelectIntegrationTypeStep({ onSelect, onCancel }: SelectIntegrationTypeStepProps) {
	const [selected, setSelected] = useState<IntegrationType | null>(null)

	return (
		<div className='flex flex-col gap-6'>
			<div>
				<Text variant='medium' weight='semibold' className='mb-1'>
					Select Integration Type
				</Text>
				<Text variant='small' className='text-neutral-600'>
					Choose how you want to connect your deal management system.
				</Text>
			</div>

			<div className='grid grid-cols-1 sm:grid-cols-2 gap-4'>
				{/* CRM Integration Card */}
				<button
					type='button'
					onClick={() => setSelected('crm')}
					className={`text-left p-5 rounded-lg border-2 transition-all cursor-pointer ${
						selected === 'crm'
							? 'border-primary-600 bg-primary-50 shadow-sm'
							: 'border-neutral-200 bg-white hover:border-neutral-300 hover:shadow-sm'
					}`}>
					<div className='flex items-center gap-3 mb-3'>
						<div className='p-2 bg-primary-100 rounded-lg'>
							<svg
								className='w-5 h-5 text-primary-600'
								fill='none'
								viewBox='0 0 24 24'
								stroke='currentColor'
								aria-hidden='true'>
								<path
									strokeLinecap='round'
									strokeLinejoin='round'
									strokeWidth={1.5}
									d='M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1'
								/>
							</svg>
						</div>
						<Text variant='medium' weight='semibold'>
							CRM Integration
						</Text>
					</div>
					<Text variant='small' className='text-neutral-600'>
						Connect to Salesforce, DealCloud, or HubSpot to automatically trigger cycles when deals reach key
						milestones.
					</Text>
				</button>

				{/* Webhook Card */}
				<button
					type='button'
					onClick={() => setSelected('webhook')}
					className={`text-left p-5 rounded-lg border-2 transition-all cursor-pointer ${
						selected === 'webhook'
							? 'border-primary-600 bg-primary-50 shadow-sm'
							: 'border-neutral-200 bg-white hover:border-neutral-300 hover:shadow-sm'
					}`}>
					<div className='flex items-center gap-3 mb-3'>
						<div className='p-2 bg-primary-100 rounded-lg'>
							<svg
								className='w-5 h-5 text-primary-600'
								fill='none'
								viewBox='0 0 24 24'
								stroke='currentColor'
								aria-hidden='true'>
								<path
									strokeLinecap='round'
									strokeLinejoin='round'
									strokeWidth={1.5}
									d='M8.288 15.038a5.25 5.25 0 017.424 0M5.106 11.856c3.807-3.808 9.98-3.808 13.788 0M1.924 8.674c5.565-5.565 14.587-5.565 20.152 0M12.53 18.22l-.53.53-.53-.53a.75.75 0 011.06 0z'
								/>
							</svg>
						</div>
						<Text variant='medium' weight='semibold'>
							Webhook
						</Text>
					</div>
					<Text variant='small' className='text-neutral-600'>
						Receive deal events via custom webhooks from any system. Configure endpoint URLs and payload mapping.
					</Text>
				</button>
			</div>

			<div className='flex justify-end gap-3 pt-2'>
				<Button variant='secondary' onClick={onCancel}>
					Cancel
				</Button>
				<Button variant='primary' onClick={() => selected && onSelect(selected)} disabled={!selected}>
					Next
				</Button>
			</div>
		</div>
	)
}
